module.exports = __webpack_public_path__ + "img/photo3.e72d0f3b.jpg";